import { useGlobalStore, useUserStore } from '@shared/store';
import { commonApi } from '../../apis';
import CryptoJS from 'crypto-js';
import { searchToJson, isJSON } from '@shared/utils';

// 初始化当前经理信息
export const initStaffInfo = async () => {
  try {
    const staffId = useGlobalStore().firstEntryStaffId || '';
    const { ret, retdata = {} } = await commonApi.getStaffInfo<any, any>({
      staffId,
    });

    if (ret === 0 && retdata) {
      const _key = CryptoJS.enc.Utf8.parse(searchToJson()?.currentCorpId?.padEnd?.(32, ' '));
      const decrypt = CryptoJS.AES.decrypt(retdata, _key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      const decryptData = CryptoJS.enc.Utf8.stringify(decrypt).toString();
      const data = isJSON(decryptData) ? JSON.parse(decryptData) : {};
      console.log('原始staffId', data);
      useUserStore().setViewStaffInfo(data);
    }
  } catch (error) {
    console.log('初始化当前经理信息错误：', error);
  }
};
